(function($) {

		var validation = true;
	
		function email_is_valid(email) {
			var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return email != '' && re.test(email);			
		}
	
	
		function validation_result($input, valid, message) {
			
			var $parent = $input.parents('label');
			var message_el = $('<div class="error_message alert alert-danger"></div>');
						
			if( valid ) {

//				console.log('is-valid');
				
				$parent.find('.error_message').remove();
				$parent.removeClass('is-invalid');
				$parent.addClass('is-valid');
				
			} else {
				
//				console.log('is-invalid');
				
				$parent.removeClass('is-valid');
				$parent.addClass('is-invalid');				
				
				if( message != '' ) {
					message_el.html(message);
					$parent.append(message_el)
				}
			}
			
		}
		
		function validation_init(e) {
			
			if( !validation )
				return false;
				
			var $this = $(this);
			var valid = true;
			var message = '';
			
			if( $this.attr('type') == 'email' ) {
				
				if( !email_is_valid($this.val()) ) {
					valid = false;
					message = 'Incorrect format';
				}
				
			} else if( $this.hasClass('password_confirmation') ) {
				
				var value = $this.val();
				var target = $($this.data('confirmation'));
				
				if( value !== target.val() || value == '' ) {
					valid = false;
					message = 'Password does not match';
				}
				
			} else {
				
				if( $this.val() == '' ) {
					valid = false;
					message = 'Required field';
				}
				
			}
			
			validation_result($this, valid, message);
			
		}
		
		$(document).ready(function() {
			
			$('input.validate').on('validate', validation_init);
			$('select.validate').on('validate', validation_init);

			$('.validate').on('focusin', function(e) {

				var $parent = $(this).parents('label');

				$parent.removeClass('is-valid is-invalid');
				$parent.find('.error_message').remove();

			});
			
		});
		
})(jQuery);